ceregoCommon.factory('SessionsResource', ['$resource', ($resource) ->
  $resource "", {},
    create:
      method: 'POST'
      isArray: false
      url: Packs.iKnowRoutes.v2_sessions_path()
])
